(function () {
  'use strict';

  const selectors = {
    productImage: '[data-image-id]',
    productImagesContainer: 'product-images',
    section: '[data-section-id]',
    thumbsToBottom: '[data-thumbs-to-bottom]',
    thumbsToLeft: '[data-thumbs-to-left]',
    thumbsToRight: '[data-thumbs-to-right]',
    thumbsToTop: '[data-thumbs-to-top]',
    thumbItem: '[data-thumb-item]',
    thumbLink: '[data-thumb-link]',
    thumbsSlider: '[data-thumbs-slider]',
  };

  const attributes = {
    activeMedia: 'data-active-media',
    mediaId: 'data-media-id',
  };

  const classes = {
    active: 'is-active',
  };

  if (!customElements.get('product-thumbs')) {
    customElements.define(
      'product-thumbs',
      class extends HTMLElement {
        constructor() {
          super();

          this.container = this.closest(selectors.section);
          this.productImages = this.container?.querySelectorAll(selectors.productImage) || [];
          this.productImagesContainer = this.container?.querySelector(selectors.productImagesContainer);
          this.productThumbs = this.container?.querySelectorAll(selectors.thumbItem) || [];
          this.thumbSlider = this.querySelector(selectors.thumbsSlider);
          this.thumbLinks = this.querySelectorAll(selectors.thumbLink);
          this.thumbsToTopButton = this.querySelector(selectors.thumbsToTop);
          this.thumbsToBottomButton = this.querySelector(selectors.thumbsToBottom);
          this.thumbsToLeftButton = this.querySelector(selectors.thumbsToLeft);
          this.thumbsToRightButton = this.querySelector(selectors.thumbsToRight);

          this.pointerIsDown = false;
          this.activePointerId = null;
          this.dragStartX = 0;
          this.dragStartY = 0;
          this.startScrollLeft = 0;
          this.startScrollTop = 0;
          this.hasDragged = false;
          this.lastDragAt = 0;

          this.handlePointerDown = this.handlePointerDown.bind(this);
          this.handlePointerMove = this.handlePointerMove.bind(this);
          this.handlePointerUp = this.handlePointerUp.bind(this);
          this.handleDragStart = this.handleDragStart.bind(this);
          this.handleThumbsToTop = this.handleThumbsToTop.bind(this);
          this.handleThumbsToBottom = this.handleThumbsToBottom.bind(this);
          this.handleThumbsToLeft = this.handleThumbsToLeft.bind(this);
          this.handleThumbsToRight = this.handleThumbsToRight.bind(this);
          this.updateThumbsScrollButtons = this.updateThumbsScrollButtons.bind(this);
        }

        connectedCallback() {
          this.handleEvents();
          this.preloadImagesOnHover();
          this.activeMediaObserver();
          this.initDragScroll();
          this.initThumbsScrollButtons();
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }

          this.destroyDragScroll();
          this.destroyThumbsScrollButtons();
        }

        activeMediaObserver() {
          if (!this.productImagesContainer) return;

          this.observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === attributes.activeMedia) {
                this.setActiveThumb();
              }
            }
          });

          this.observer.observe(this.productImagesContainer, {
            attributes: true,
            childList: false,
            subtree: false,
          });
        }

        stopGalleryMedia() {
          if (!this.productImagesContainer) return;

          this.productImagesContainer.querySelectorAll('[data-host="youtube"]').forEach((video) => {
            video.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          });

          this.productImagesContainer.querySelectorAll('[data-host="vimeo"]').forEach((video) => {
            video.contentWindow?.postMessage('{"method":"pause"}', '*');
          });

          this.productImagesContainer.querySelectorAll('video').forEach((video) => video.pause());

          this.productImagesContainer.querySelectorAll('product-model').forEach((model) => {
            if (model.modelViewerUI) {
              model.modelViewerUI.pause();
            }
          });
        }

        handleEvents() {
          this.thumbLinks?.forEach((thumbLink) => {
            thumbLink.setAttribute('draggable', 'false');

            thumbLink.addEventListener('click', (event) => {
              event.preventDefault();

              if (Date.now() - this.lastDragAt < 250) {
                return;
              }

              this.stopGalleryMedia();

              const thumbItem = thumbLink.closest(selectors.thumbItem);
              const mediaId = thumbLink.getAttribute(attributes.mediaId);

              if (!thumbItem.classList.contains(classes.active)) {
                this.dispatchEvent(
                  new CustomEvent('theme:media:select', {
                    bubbles: true,
                    detail: {id: mediaId},
                  })
                );
              }
            });

            thumbLink.addEventListener('keyup', (event) => {
              if (event.code !== 'Enter') return;

              this.stopGalleryMedia();

              const mediaId = thumbLink.getAttribute(attributes.mediaId);
              const focusElement = this.productImagesContainer
                ?.querySelector(`[${attributes.mediaId}="${mediaId}"]`)
                ?.querySelectorAll('model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])')[0];

              if (focusElement) {
                focusElement.dispatchEvent(new Event('focus'));
                focusElement.dispatchEvent(new Event('select'));
              }
            });
          });
        }

        initDragScroll() {
          if (!this.thumbSlider) return;

          this.thumbSlider.style.touchAction = 'none';
          this.thumbSlider.style.userSelect = 'none';
          this.thumbSlider.addEventListener('pointerdown', this.handlePointerDown);
          window.addEventListener('pointermove', this.handlePointerMove);
          window.addEventListener('pointerup', this.handlePointerUp);
          window.addEventListener('pointercancel', this.handlePointerUp);
          this.thumbSlider.addEventListener('dragstart', this.handleDragStart);
        }

        destroyDragScroll() {
          if (!this.thumbSlider) return;

          this.thumbSlider.removeEventListener('pointerdown', this.handlePointerDown);
          window.removeEventListener('pointermove', this.handlePointerMove);
          window.removeEventListener('pointerup', this.handlePointerUp);
          window.removeEventListener('pointercancel', this.handlePointerUp);
          this.thumbSlider.removeEventListener('dragstart', this.handleDragStart);
        }

        handlePointerDown(event) {
          if (!this.thumbSlider) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;

          this.pointerIsDown = true;
          this.activePointerId = event.pointerId;
          this.dragStartX = event.clientX;
          this.dragStartY = event.clientY;
          this.startScrollLeft = this.thumbSlider.scrollLeft;
          this.startScrollTop = this.thumbSlider.scrollTop;
          this.hasDragged = false;
        }

        handleDragStart(event) {
          event.preventDefault();
        }

        handlePointerMove(event) {
          if (!this.pointerIsDown || this.activePointerId !== event.pointerId || !this.thumbSlider) return;

          const deltaX = event.clientX - this.dragStartX;
          const deltaY = event.clientY - this.dragStartY;

          if (!this.hasDragged && (Math.abs(deltaX) > 12 || Math.abs(deltaY) > 12)) {
            this.hasDragged = true;
          }

          const canScrollVertically = this.thumbSlider.scrollHeight > this.thumbSlider.clientHeight;
          const canScrollHorizontally = this.thumbSlider.scrollWidth > this.thumbSlider.clientWidth;

          if (canScrollVertically) {
            this.thumbSlider.scrollTop = this.startScrollTop - deltaY;
          }

          if (canScrollHorizontally) {
            this.thumbSlider.scrollLeft = this.startScrollLeft - deltaX;
          }

          if (this.hasDragged) {
            event.preventDefault();
          }
        }

        handlePointerUp(event) {
          if (!this.pointerIsDown) return;
          if (event.pointerId !== undefined && this.activePointerId !== event.pointerId) return;

          if (this.hasDragged) {
            this.lastDragAt = Date.now();
          }

          this.pointerIsDown = false;
          this.activePointerId = null;
          this.hasDragged = false;
        }

        preloadImagesOnHover() {
          this.thumbLinks?.forEach((thumbLink) => {
            thumbLink.addEventListener('mouseover', () => {
              const mediaId = thumbLink.getAttribute(attributes.mediaId);
              this.productImagesContainer?.querySelector(`[${attributes.mediaId}="${mediaId}"] img`)?.setAttribute('loading', 'eager');
            });
          });
        }

        initThumbsScrollButtons() {
          if (!this.thumbSlider) return;

          this.thumbsToTopButton?.addEventListener('click', this.handleThumbsToTop);
          this.thumbsToBottomButton?.addEventListener('click', this.handleThumbsToBottom);
          this.thumbsToLeftButton?.addEventListener('click', this.handleThumbsToLeft);
          this.thumbsToRightButton?.addEventListener('click', this.handleThumbsToRight);
          this.thumbSlider.addEventListener('scroll', this.updateThumbsScrollButtons, {passive: true});
          window.addEventListener('resize', this.updateThumbsScrollButtons);

          this.updateThumbsScrollButtons();
        }

        destroyThumbsScrollButtons() {
          if (!this.thumbSlider) return;

          this.thumbsToTopButton?.removeEventListener('click', this.handleThumbsToTop);
          this.thumbsToBottomButton?.removeEventListener('click', this.handleThumbsToBottom);
          this.thumbsToLeftButton?.removeEventListener('click', this.handleThumbsToLeft);
          this.thumbsToRightButton?.removeEventListener('click', this.handleThumbsToRight);
          this.thumbSlider.removeEventListener('scroll', this.updateThumbsScrollButtons);
          window.removeEventListener('resize', this.updateThumbsScrollButtons);
        }

        handleThumbsToTop() {
          if (!this.thumbSlider) return;

          this.thumbSlider.scrollBy({
            top: -this.getThumbScrollStep('vertical'),
            behavior: 'smooth',
          });
        }

        handleThumbsToBottom() {
          if (!this.thumbSlider) return;

          this.thumbSlider.scrollBy({
            top: this.getThumbScrollStep('vertical'),
            behavior: 'smooth',
          });
        }

        handleThumbsToLeft() {
          if (!this.thumbSlider) return;

          const {minScrollLeft} = this.getHorizontalScrollBounds();
          const targetLeft = Math.max(this.thumbSlider.scrollLeft - this.getThumbScrollStep('horizontal'), minScrollLeft);

          this.thumbSlider.scrollTo({
            left: targetLeft,
            behavior: 'smooth',
          });
        }

        handleThumbsToRight() {
          if (!this.thumbSlider) return;

          const {maxScrollLeft} = this.getHorizontalScrollBounds();
          const targetLeft = Math.min(this.thumbSlider.scrollLeft + this.getThumbScrollStep('horizontal'), maxScrollLeft);

          this.thumbSlider.scrollTo({
            left: targetLeft,
            behavior: 'smooth',
          });
        }

        getHorizontalScrollBounds() {
          if (!this.thumbSlider) {
            return {
              minScrollLeft: 0,
              maxScrollLeft: 0,
            };
          }

          const thumbItems = [...this.thumbSlider.querySelectorAll(selectors.thumbItem)];
          if (!thumbItems.length) {
            return {
              minScrollLeft: 0,
              maxScrollLeft: Math.max(0, this.thumbSlider.scrollWidth - this.thumbSlider.clientWidth),
            };
          }

          const lastItem = thumbItems[thumbItems.length - 1];
          const maxByThumbItems = Math.max(
            0,
            lastItem.offsetLeft + lastItem.offsetWidth - this.thumbSlider.clientWidth
          );
          const maxByScrollWidth = Math.max(0, this.thumbSlider.scrollWidth - this.thumbSlider.clientWidth);

          return {
            minScrollLeft: 0,
            maxScrollLeft: Math.min(maxByThumbItems, maxByScrollWidth),
          };
        }

        getThumbScrollStep(direction) {
          if (!this.thumbSlider) return 0;

          const thumbItems = [...this.thumbSlider.querySelectorAll(selectors.thumbItem)];
          if (!thumbItems.length) return 0;

          const firstItem = thumbItems[0];
          const secondItem = thumbItems[1];
          let itemStep = 0;

          if (direction === 'vertical') {
            itemStep = secondItem ? Math.abs(secondItem.offsetTop - firstItem.offsetTop) : firstItem.offsetHeight;
          } else {
            itemStep = secondItem ? Math.abs(secondItem.offsetLeft - firstItem.offsetLeft) : firstItem.offsetWidth;
          }

          if (!itemStep) {
            itemStep = direction === 'vertical' ? firstItem.offsetHeight : firstItem.offsetWidth;
          }

          return itemStep * 4;
        }

        updateSingleButtonState(button, canScroll, isAtBoundary) {
          if (!button) return;

          button.classList.toggle('is-hidden', !canScroll);
          button.tabIndex = canScroll ? 0 : -1;
          button.disabled = !canScroll || isAtBoundary;
        }

        updateThumbsScrollButtons() {
          if (!this.thumbSlider) return;

          const canScrollVertically = this.thumbSlider.scrollHeight > this.thumbSlider.clientHeight + 1;
          const maxScrollTop = this.thumbSlider.scrollHeight - this.thumbSlider.clientHeight;
          const {maxScrollLeft} = this.getHorizontalScrollBounds();
          const canScrollHorizontally = maxScrollLeft > 1;
          const currentScrollTop = this.thumbSlider.scrollTop;
          const currentScrollLeft = this.thumbSlider.scrollLeft;

          this.updateSingleButtonState(this.thumbsToTopButton, canScrollVertically, currentScrollTop <= 1);
          this.updateSingleButtonState(this.thumbsToBottomButton, canScrollVertically, currentScrollTop >= maxScrollTop - 1);
          this.updateSingleButtonState(this.thumbsToLeftButton, canScrollHorizontally, currentScrollLeft <= 1);
          this.updateSingleButtonState(this.thumbsToRightButton, canScrollHorizontally, currentScrollLeft >= maxScrollLeft - 1);
        }

        setActiveThumb() {
          if (!this.productImagesContainer) return;

          const activeMediaId = this.productImagesContainer.getAttribute(attributes.activeMedia);
          const activeThumb = this.querySelector(`[${attributes.mediaId}="${activeMediaId}"]`);

          this.querySelector(`${selectors.thumbItem}.${classes.active}`)?.classList.remove(classes.active);
          activeThumb?.parentNode?.classList.add(classes.active);

          requestAnimationFrame(() => {
            this.scrollToThumb();
            this.updateThumbsScrollButtons();
          });
        }

        scrollToThumb() {
          const slider = this.thumbSlider;
          if (!slider) return;

          const activeItem = slider.querySelector(`.${classes.active}`);
          if (!activeItem) return;

          const currentTop = slider.scrollTop;
          const currentLeft = slider.scrollLeft;
          const sliderWidth = slider.offsetWidth;
          const sliderHeight = slider.offsetHeight;
          const sliderBottom = currentTop + sliderHeight;
          const sliderRight = currentLeft + sliderWidth;
          const itemTop = activeItem.offsetTop;
          const itemLeft = activeItem.offsetLeft;
          const itemWidth = activeItem.offsetWidth;
          const itemHeight = activeItem.offsetHeight;
          const isAbove = currentTop > itemTop;
          const isLeft = currentLeft > itemLeft;
          const isRight = itemLeft + itemWidth > sliderRight;
          const needsVerticalScroll = itemTop + itemHeight > sliderBottom || isAbove;
          const needsHorizontalScroll = isRight || isLeft;
          const isMobile = window.theme.isMobile();

          if (!needsVerticalScroll && !needsHorizontalScroll) return;

          let targetTop = itemTop - sliderHeight + itemHeight;
          let targetLeft = itemLeft - sliderWidth + itemWidth;

          if (isAbove) {
            targetTop = itemTop;
          }

          if (isRight && isMobile) {
            targetLeft += parseInt(window.getComputedStyle(slider).paddingRight, 10);
          }

          if (isLeft) {
            targetLeft = itemLeft;

            if (isMobile) {
              targetLeft -= parseInt(window.getComputedStyle(slider).paddingLeft, 10);
            }
          }

          const {maxScrollLeft} = this.getHorizontalScrollBounds();
          targetLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));

          slider.scrollTo({
            top: targetTop,
            left: targetLeft,
            behavior: 'smooth',
          });
        }
      }
    );
  }
})();
